import { getStore } from 'mini-mail-folder-store/lib/store/Store';
import { mutatorAction } from 'satcheljs';
import { PerformanceDatapoint } from 'owa-analytics';

export const openLeftNavPerfDatapointInitializer = mutatorAction(
    'openLeftNavPerfDatapointInitializer',
    (initialize: boolean) => {
        const mailStore = getStore();
        mailStore.perfDatapoint = initialize ? new PerformanceDatapoint('LeftNavOpen') : null;
    }
);

export default openLeftNavPerfDatapointInitializer;
